"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DisplayExample_1 = require("./DisplayExample");
exports.default = DisplayExample_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/DisplayExample/index.js
// module id = 1245
// module chunks = 8